const videoLanguageMap = {
  en: 'https://media2.ldscdn.org/assets/rootstech/rootstech-2023/2023-03-0060-who-is-familysearch-1080p-eng.mp4',
  fr: 'https://assets.churchofjesuschrist.org/1c60091fae3c11ed9384eeeeac1ebd7c377a3393-1080p-fr.mp4',
}

export default videoLanguageMap
